import { useAuthStore } from "@app/store";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { PagesRoutes } from "../pages.routes";

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Route guard to protect authenticated routes
 * Redirects to login if user is not authenticated
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to={PagesRoutes.auth.login} replace />;
  }

  return <>{children}</>;
}
